export const MESSAGE_FILE_FIELD_NAME: string = "fileUp";
export const MESSAGE_UP_URL: string = "character/file/up";
